var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-dialog',{attrs:{"dialogState":_vm.dialogState,"dialogTitle":_vm.dialogTitle,"dialogText":_vm.dialogText,"confirmDialog":true,"actions":{
    show: true,
    secondaryButtonFunction: _vm.toggleConfirmDialog,
    primaryButtonFunction: function () { return _vm.makeAsDefaultPayment(_vm.cardId); },
    primaryButtonShow: true,
    secondaryButtonText: 'Cancel',
    primaryButtonText: 'Confirm',
    primaryButtonDisabled: _vm.isPrimaryButtonDisabled
  },"data-test-id":"mark-payment-card-as-default-dialog"},on:{"toggleModal":_vm.toggleConfirmDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }